<template lang="pug">
.contacts-listing__card(v-if="contact.emailAddress || contact.phoneNumber || contact.phoneNumberLong")
	.contacts-listing__card-content 
		h4.contacts-listing__card-name(v-if="displayName") {{ displayName }}
		.contacts-listing__card-info(v-if="contact.serviceName || contact.positionTitle")
			span.contacts-listing__card-info-item(v-if="contact.product && displayName != contact.product") {{ contact.product }}
			span.contacts-listing__card-info-item(v-if="contact.positionTitle") {{ contact.positionTitle }}
		a(:href="'mailto:' + contact.emailAddress", v-if="contact.emailAddress").contacts-listing__card-email {{ contact.emailAddress }}
		a(:href="'tel:' + phoneAttr", v-if="contact.phoneNumber || contact.phoneNumberLong").contacts-listing__card-email {{ phoneDisplay }}
</template>

<script>
export default {
	name: "ContactCard",
	props: {
		contact: Object
	},
	computed: {
		displayName() {
			let str = "";
			if (!this.contact.firstName && !this.contact.lastName) return !!this.contact.product ? this.contact.product : false;
			else {
				if (!!this.contact.firstName) str += this.contact.firstName;
				if (!!this.contact.lastName) str += " " + this.contact.lastName;
			}
			return str;
		},
		phoneAttr() {
			return !!this.contact.phoneNumberLong ? this.contact.phoneNumberLong.toString() : this.contact.phoneNumber;
		},
		phoneDisplay() {
			return !!this.contact.phoneNumber ? this.contact.phoneNumber : this.contact.phoneNumberLong.toString();
		},
	},
	methods: {},
}
</script>

<style scoped lang="scss">
.contacts-listing {
	&__card {
		display: flex;
		text-align: left;
		box-shadow: 0 0 6px rgba($black, 0.15);
		border: 1px solid $midGray;
		border-radius: 0.5rem;
		padding: 1.25rem;
		flex: 1 1 100%;
		@include mq(sm) {
			flex: 0 1 calc(50% - 0.75rem);
		}
		@include mq(md) {
			flex: 0 1 calc(33.333% - 1rem);
		}
		&-content {
			display: flex;
			flex-direction: column;
			gap: 0.5rem;
			a {
				color: $brightBlueAltOrg;
				text-decoration: none;
				&:hover {
					text-decoration: underline;
				}
			}
		}
		&-name {
			margin-bottom: 0;
		}
		&-info {
			font-size: 0.9375rem;
			display: flex;
			gap: 0.5rem 0.75rem;
			flex-wrap: wrap;
			&-item {
				&:not(:last-of-type) {
					display: flex;
					gap: 0.75rem;
					&::after {
						content: "|";
					}
				}
			}
		}
	}
}
</style>